"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _edSystem = require("@eduact/ed-system");
var _react = _interopRequireDefault(require("react"));
var _Icons = require("../../Icons");
var _Spacer = _interopRequireDefault(require("../../Spacer"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _Modal = require("../Modal");
var _templateObject, _templateObject2;
var _excluded = ["open", "bgColor", "children", "withBackdrop", "withDelay", "withStyling", "persistent", "onClose"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Dialog = function Dialog(_ref) {
  var open = _ref.open,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? 'light' : _ref$bgColor,
    children = _ref.children,
    withBackdrop = _ref.withBackdrop,
    withDelay = _ref.withDelay,
    withStyling = _ref.withStyling,
    persistent = _ref.persistent,
    onClose = _ref.onClose,
    props = _objectWithoutProperties(_ref, _excluded);
  var modalProps = {
    withBackdrop: withBackdrop,
    withDelay: withDelay,
    withStyling: withStyling,
    persistent: persistent,
    onClose: onClose
  };
  return /*#__PURE__*/_react["default"].createElement(_Modal.Modal, _extends({}, modalProps, {
    open: open,
    withStyling: true,
    center: true
  }), /*#__PURE__*/_react["default"].createElement(StyledDialogWrapper, _extends({}, props, {
    bgColor: bgColor
  }), /*#__PURE__*/_react["default"].createElement(ToggleButton, {
    onClick: function onClick() {
      return onClose === null || onClose === void 0 ? void 0 : onClose();
    },
    top: 0,
    right: 0
  }, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    p: '0.5rem'
  }, /*#__PURE__*/_react["default"].createElement(_Icons.Icons.Close, null))), children));
};
var _default = Dialog;
exports["default"] = _default;
var StyledDialogWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", ";\n\tposition: relative;\n\tborder-radius: 20px;\n\theight: 60vh;\n\twidth: 80vw;\n\t", ";\n\t", ";\n\t", ";\n"])), (0, _styledSystem.variant)({
  prop: 'bgColor',
  scale: 'backgrounds'
}), _styledSystem.borderRadius, _styledSystem.layout, _styledSystem.space);
var ToggleButton = (0, _styledComponents["default"])(_edSystem.Stack)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tz-index: 9999999;\n"])));